import { Link } from 'react-router-dom'
import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

function HomePage() {
  const { isAuthenticated, user, logout } = useAuth()

  if (!isAuthenticated) {
    return <LoginForm />
  }

  return (
    <div className="container">
      <div className="header">
        <h1>🏥 Hospital Alert System</h1>
        <p>Emergency alert system for hospital rooms</p>
      </div>
      
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <div>
            <h2>Welcome, {user?.username}!</h2>
            <p style={{ color: 'var(--text-muted)', margin: 0 }}>Role: {user?.role}</p>
          </div>
          <button 
            className="btn btn-secondary"
            onClick={logout}
          >
            Logout
          </button>
        </div>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          <div className="card">
            <h3>👨‍⚕️ Admin Dashboard</h3>
            <p>Manage hospitals, rooms, and view emergency alerts</p>
            <Link to="/dashboard" className="btn btn-primary">
              Access Dashboard
            </Link>
          </div>
          
          <div className="card">
            <h3>📱 Room Access</h3>
            <p>Access emergency button for specific hospital rooms</p>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
              Room access requires a QR code or direct room link
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

function LoginForm() {
  const { login, loading } = useAuth()
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  })
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    
    const success = await login(formData.username, formData.password)
    if (!success) {
      setError('Invalid credentials')
    }
  }

  return (
    <div className="container">
      <div className="header">
        <h1>🏥 Hospital Alert System</h1>
        <p>Emergency alert system for hospital rooms</p>
      </div>
      
      <div className="card login-card">
        <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Login</h2>
        
        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
            />
          </div>
          
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default HomePage